import { IThreadFilters } from '@/client/api';
import { atom } from 'recoil';


export const threadsFiltersState = atom<IThreadFilters>({
  key: 'ThreadsFilters',
  default: {}
});
